module.exports = __webpack_public_path__ + "img/pano-coors-light.adaccf4e.jpg";